import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);

// Register Firebase Messaging service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log(
        '[main.ts] Firebase SW registered with scope:',
        registration.scope
      );
      // Force the browser to check for a new version of the SW file on every page load.
      // This ensures deployed updates to the SW are picked up promptly,
      // regardless of HTTP cache headers.
      registration.update();
    })
    .catch((err) => {
      console.warn('[main.ts] Firebase SW registration failed:', err);
    });
}
